/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import LetterContainer from "../LetterContainer";
import { useLayoutEffect, useState, useEffect } from "react";
import styles from "./letterGrid.module.scss";
import clsx from "clsx";
import { applyFontWeight } from "../../utils/fontWeightCalculator";
import Letter from "../Letter";

export default function LetterGrid(props) {
  const {
    tiles,
    onTileUp,
    onTileDown,
    onPointerMove,
    keyboardChain,
    navigationMode,
    ref,
    active,
    gridSize,
    tileRefs,
    className,
    children,
  } = props;

  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.style.setProperty("--gridSize", gridSize);
      applyFontWeight(ref.current, gridSize);
    }
  }, [gridSize, ref]);

  useEffect(() => {
    if (tileRefs.current[0]) {
      tileRefs.current[0].focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tiles]);

  useEffect(() => {
    if (!active) return;

    const handleGlobalPointerMove = (evt) => {
      let x, y;

      if (evt.type === 'touchmove' || evt.type === 'touchstart') {
        if (evt.touches && evt.touches.length > 0) {
          x = evt.touches[0].clientX;
          y = evt.touches[0].clientY;
        } else {
          return;
        }
      } else {
        x = evt.clientX;
        y = evt.clientY;
      }

      if (typeof x === 'number' && typeof y === 'number' &&
        isFinite(x) && isFinite(y) && x >= 0 && y >= 0) {
        onPointerMove(x, y);
      }
    };

    const handleGlobalPointerUp = () => {
      onTileUp();
    };

    const handleGlobalPointerCancel = () => {
      onTileUp();
    };

    document.addEventListener("pointermove", handleGlobalPointerMove, { passive: true });
    document.addEventListener("pointerup", handleGlobalPointerUp);
    document.addEventListener("pointercancel", handleGlobalPointerCancel);

    document.addEventListener("mousemove", handleGlobalPointerMove, { passive: true });
    document.addEventListener("mouseup", handleGlobalPointerUp);
    document.addEventListener("touchmove", handleGlobalPointerMove, { passive: true });
    document.addEventListener("touchend", handleGlobalPointerUp);
    document.addEventListener("touchcancel", handleGlobalPointerCancel);

    return () => {
      document.removeEventListener("pointermove", handleGlobalPointerMove);
      document.removeEventListener("pointerup", handleGlobalPointerUp);
      document.removeEventListener("pointercancel", handleGlobalPointerCancel);
      document.removeEventListener("mousemove", handleGlobalPointerMove);
      document.removeEventListener("mouseup", handleGlobalPointerUp);
      document.removeEventListener("touchmove", handleGlobalPointerMove);
      document.removeEventListener("touchend", handleGlobalPointerUp);
      document.removeEventListener("touchcancel", handleGlobalPointerCancel);
    };
  }, [active, onPointerMove, onTileUp]);

  return (
    <div
      ref={ref}
      className={clsx(className, styles.letterGrid)}
      onPointerDown={(evt) => {
        let x, y;

        if (evt.type === 'touchstart') {
          if (evt.touches && evt.touches.length > 0) {
            x = evt.touches[0].clientX;
            y = evt.touches[0].clientY;
          } else {
            return;
          }
        } else {
          x = evt.clientX;
          y = evt.clientY;
        }

        if (typeof x === 'number' && typeof y === 'number' &&
          isFinite(x) && isFinite(y) && x >= 0 && y >= 0) {
          onTileDown(x, y);
        }
      }}
    >
      {tiles &&
        tiles.map((tile, idx) => (
          <LetterContainer
            key={idx}
            tile={tile}
            ref={tileRefs}
            keyboardChain={keyboardChain}
            navigationMode={navigationMode}
          />
        ))}
      {children}
      <div className={clsx(styles.letterGrid, styles.letterGridOverlay)}>
        {tiles.map((tile, idx) => (
          <Letter
            key={idx}
            keyboardChain={keyboardChain}
            navigationMode={navigationMode}
            tile={tile}
          />
        ))}
      </div>
    </div>
  );
}
